module.exports = __webpack_public_path__ + "static/media/game-display-3@2x.b802dfea.png";